<template lang="pug">
.columns.date-picker-columns.is-desktop
  template(v-if="isTypeDateRange")
    .column
      BField(label="Date Range")
        BDatepicker(
          placeholder="Click to select..."
          icon="calendar-today"
          editable
          v-model="dates"
          :date-parser="(date) => dateParser(date)"
          :date-formatter="(date) => this.date(dates[0], 'DATE_FORMAT_SLASH').formatted + ' - ' + this.date(dates[1], 'DATE_FORMAT_SLASH').formatted"
          :max-date="moment()._d"
          :position="position"
          range
        )
  template(v-else)
    .column
      BField(label="Start Date")
        BDatepicker(
          placeholder="Click to select..."
          icon="calendar-today"
          editable
          v-model="startDate"
          :date-formatter="(date) => this.date(date, 'DATE_FORMAT_SHORT_MONTH').formatted"
          :events="startDatePickerEvents"
          :max-date="moment()._d"
          :position="position"
        )
    .column
      BField(label="End Date")
        BDatepicker(
          placeholder="Click to select..."
          icon="calendar-today"
          editable
          v-model="endDate"
          :date-formatter="(date) => this.date(date, 'DATE_FORMAT_SHORT_MONTH').formatted"
          :min-date="startDate"
          :max-date="moment()._d"
          :events="endDatePickerEvents"
          :position="position"
        )
  .column.is-narrow.is-flex
      WtButton(
        :style="{ 'align-self': 'flex-end' }"
        color="primary"
        :loading="isLoading"
        @click.native="fetchActionWrapper"
      ) SHOW DATE RANGE
</template>

<script>
import WtButton from "@@/WtButton/WtButton";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";

export default {
  name: "WtBetweenDatesInput",

  components: { WtButton },

  mixins: [dateUtilityMixin],

  props: {
    fetchAction: {
      type: Function,
      default: () => {}
    },
    position: {
      type: String,
      default: undefined
    },
    isTypeDateRange: {
      type: Boolean,
      default: true
    },
    initDates: {
      type: Array,
      default: () => [new Date(), new Date()]
    }
  },

  data() {
    return {
      isLoading: false,
      startDate: this.initDates[0],
      endDate: this.initDates[1],
      dates: this.initDates
    };
  },

  computed: {
    endDatePickerEvents() {
      return this.startDate ? [this.startDate] : null;
    },

    startDatePickerEvents() {
      return this.endDate ? [this.endDate] : null;
    }
  },

  watch: {
    dates() {
      this.$emit("newDates", this.dates);
    }
  },

  methods: {
    async fetchActionWrapper() {
      this.isLoading = true;
      let startDate = this.isTypeDateRange ? this.dates[0] : this.startDate;
      let endDate = this.isTypeDateRange ? this.dates[1] : this.endDate;
      const response = await this.fetchAction({
        startDate,
        endDate
      });
      this.$emit("newData", response);
      this.isLoading = false;
    },

    dateParser(dateRangeString) {
      const dateRangeArray = dateRangeString.split("-");
      return [
        new Date(Date.parse(dateRangeArray[0])),
        new Date(Date.parse(dateRangeArray[1]))
      ];
    }
  }
};
</script>

<style lang="sass" scoped></style>
